import { tick } from '@boba-cli/tea';
import { Style } from '@boba-cli/chapstick';

// src/spinner.ts
var line = {
  frames: ["|", "/", "-", "\\"],
  fps: 100
};
var dot = {
  frames: ["\u28FE ", "\u28FD ", "\u28FB ", "\u28BF ", "\u287F ", "\u28DF ", "\u28EF ", "\u28F7 "],
  fps: 100
};
var miniDot = {
  frames: ["\u280B", "\u2819", "\u2839", "\u2838", "\u283C", "\u2834", "\u2826", "\u2827", "\u2807", "\u280F"],
  fps: 83
};
var jump = {
  frames: ["\u2884", "\u2882", "\u2881", "\u2841", "\u2848", "\u2850", "\u2860"],
  fps: 100
};
var pulse = {
  frames: ["\u2588", "\u2593", "\u2592", "\u2591"],
  fps: 125
};
var points = {
  frames: ["\u2219\u2219\u2219", "\u25CF\u2219\u2219", "\u2219\u25CF\u2219", "\u2219\u2219\u25CF"],
  fps: 143
};
var globe = {
  frames: ["\u{1F30D}", "\u{1F30E}", "\u{1F30F}"],
  fps: 250
};
var moon = {
  frames: ["\u{1F311}", "\u{1F312}", "\u{1F313}", "\u{1F314}", "\u{1F315}", "\u{1F316}", "\u{1F317}", "\u{1F318}"],
  fps: 125
};
var monkey = {
  frames: ["\u{1F648}", "\u{1F649}", "\u{1F64A}"],
  fps: 333
};
var meter = {
  frames: ["\u25B1\u25B1\u25B1", "\u25B0\u25B1\u25B1", "\u25B0\u25B0\u25B1", "\u25B0\u25B0\u25B0", "\u25B0\u25B0\u25B1", "\u25B0\u25B1\u25B1", "\u25B1\u25B1\u25B1"],
  fps: 143
};
var hamburger = {
  frames: ["\u2631", "\u2632", "\u2634", "\u2632"],
  fps: 333
};
var ellipsis = {
  frames: ["", ".", "..", "..."],
  fps: 333
};

// src/messages.ts
var TickMsg = class {
  constructor(time, id, tag) {
    this.time = time;
    this.id = id;
    this.tag = tag;
  }
  _tag = "spinner:tick";
};
var lastId = 0;
function nextId() {
  return ++lastId;
}
var SpinnerModel = class _SpinnerModel {
  spinner;
  style;
  #frame;
  #id;
  #tag;
  constructor(options = {}, state) {
    this.spinner = options.spinner ?? line;
    this.style = options.style ?? new Style();
    this.#frame = state?.frame ?? 0;
    this.#id = state?.id ?? nextId();
    this.#tag = state?.tag ?? 0;
  }
  /** Unique ID for this spinner instance (for message routing). */
  id() {
    return this.#id;
  }
  /**
   * Command to start/continue the spinner animation.
   * Call this in your model's init() or after handling a TickMsg.
   */
  tick() {
    const id = this.#id;
    const tag = this.#tag;
    return tick(this.spinner.fps, (time) => new TickMsg(time, id, tag));
  }
  /**
   * Update the model in response to messages.
   * Returns a new model and an optional command.
   */
  update(msg) {
    if (!(msg instanceof TickMsg)) {
      return [this, null];
    }
    if (msg.id > 0 && msg.id !== this.#id) {
      return [this, null];
    }
    if (msg.tag > 0 && msg.tag !== this.#tag) {
      return [this, null];
    }
    let nextFrame = this.#frame + 1;
    if (nextFrame >= this.spinner.frames.length) {
      nextFrame = 0;
    }
    const nextTag = this.#tag + 1;
    const next = new _SpinnerModel(
      { spinner: this.spinner, style: this.style },
      { frame: nextFrame, id: this.#id, tag: nextTag }
    );
    return [next, next.tick()];
  }
  /** Render the current frame with styling. */
  view() {
    const frame = this.spinner.frames[this.#frame];
    if (frame === void 0) {
      return "(error)";
    }
    return this.style.render(frame);
  }
  /** Create a new model with a different spinner. */
  withSpinner(spinner) {
    return new _SpinnerModel(
      { spinner, style: this.style },
      { frame: 0, id: this.#id, tag: this.#tag }
    );
  }
  /** Create a new model with a different style. */
  withStyle(style) {
    return new _SpinnerModel(
      { spinner: this.spinner, style },
      { frame: this.#frame, id: this.#id, tag: this.#tag }
    );
  }
};

export { SpinnerModel, TickMsg, dot, ellipsis, globe, hamburger, jump, line, meter, miniDot, monkey, moon, points, pulse };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map